const LocalStorageService = ( function() {
    
    var _service;
    
    function _getService() {
        if(!_service) {
          _service = this;
          return _service
      }
      return _service
    }

    function _setAuthTokens(keycloak) {
      localStorage.setItem('access_token', keycloak.token);
      localStorage.setItem('refresh_token', keycloak.refreshToken);
    }

    function _getAccessToken() {
      return localStorage.getItem('access_token');
    }

    function _getRefreshToken() {
    return localStorage.getItem('refresh_token');
    }

    function _setLoginUrl(url) {
      localStorage.setItem('login_url', url);
    }

    function _getLoginUrl() {
      return localStorage.getItem('login_url');
    }

    function _clearAuthTokens() {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
    }

    function _setIsDraft(app) {
        localStorage.setItem('draft', app);
    }

    function _getIsDraft() {
        return localStorage.getItem('draft');
    }

    function _clearIsDraft() {
        localStorage.removeItem('draft');
    }

    function _setOrderNumber(number) {
        localStorage.setItem('orderNumber', number);
    }

    function _getOrderNumber() {
        return localStorage.getItem('orderNumber');
    }

    function _clearOrderNumber() {
        localStorage.removeItem('orderNumber');
    }

    function _setCartItems(number) {
        localStorage.setItem('cartItems', number);
    }

    function _getCartItems() {
        let items = localStorage.getItem('cartItems');
        return items != null ? items : 0
    }

    function _clearCartItems() {
        localStorage.removeItem('cartItems');
    }

    function _setOrderType(type) {
        localStorage.setItem('orderType', type);
    }

    function _getOrderType() {
        let items = localStorage.getItem('orderType');
        return items != null ? items : null
    }

    function _clearOrderType() {
        localStorage.removeItem('orderType');
    }

   return {
      getService : _getService,
      setAuthTokens : _setAuthTokens,
      getAccessToken : _getAccessToken,
      getRefreshToken : _getRefreshToken,
      clearAuthTokens : _clearAuthTokens,
      setLoginUrl: _setLoginUrl,
      getLoginUrl: _getLoginUrl,
      setIsDraft: _setIsDraft,
      getIsDraft: _getIsDraft,
      clearIsDraft: _clearIsDraft,
      getOrderNumber: _getOrderNumber,
      setOrderNumber: _setOrderNumber,
      clearOrderNumber: _clearOrderNumber,
      getCartItems: _getCartItems,
      setCartItems: _setCartItems,
      clearCartItems: _clearCartItems,
      getOrderType: _getOrderType,
      setOrderType: _setOrderType,
      clearOrderType: _clearOrderType,
    }


   })();
   
   export default LocalStorageService;